import { schema } from 'normalizr'

const routeSchema = new schema.Entity('routes', {}, { idAttribute: 'code' })

export const routesSchema = new schema.Array(routeSchema)
